/** Stable per-item key for recharts to interpolate across a data change
 * instead of remounting: `[label, null]` for a unique label, `[label, index]`
 * for every item sharing a repeated one, so no label can forge another's key. */
export const resolveLabelKeys = <T extends { label: string }>(
    items: readonly T[]
): string[] => {
    const countByLabel = new Map<string, number>();
    items.forEach((item) => {
        countByLabel.set(item.label, (countByLabel.get(item.label) ?? 0) + 1);
    });

    return items.map((item, index) =>
        JSON.stringify([
            item.label,
            (countByLabel.get(item.label) ?? 0) > 1 ? index : null,
        ])
    );
};
